
import { defineComponent, PropType } from "vue";
import ModalVue from "../modal/Modal.vue";

export default defineComponent({
  name: "LeaveExerciseConfirm",
  components: {
    appModal: ModalVue,
  },

  props: {
    cancelHandler: { type: Function as PropType<() => void> },
    confirmHandler: { type: Function as PropType<() => void> },
  },
});
